import { Layout } from "@/components";
import ProtectedRoute from "../ProtectedRoute";
import { Role, routerRoles } from "../Router";
import { routes } from "../utils";
import { Navigate } from "react-router-dom";
import { DashboardRoutes } from "./DashbaordRoutes";
import { CommunityRoutes } from "./CommunityRoutes";
import { MasterDataRoutes } from "./MasterDataRoutes";
import { ActivityDashboardRoutes } from "./ActivityDashboardRoutes";
import { IncidentMgmtRoutes } from "./IncidentMgmtRoutes";

const CamRoutes = () => {
  return {
    // Only CAM and CAM_A allowed
    path: routes.cam,
    element: (
      <ProtectedRoute
        allowedRoles={[routerRoles.cam as Role, routerRoles.cam_a as Role]}
      />
    ),
    children: [
      {
        path: "",
        element: <Layout />,
        children: [
          {
            path: "",
            element: <Navigate to={`/${routes.cam}/${routes.dashboard}`} />,
          },
          DashboardRoutes(),
          CommunityRoutes(),
          MasterDataRoutes(),
          ActivityDashboardRoutes(),
          IncidentMgmtRoutes(),
        ],
      },
    ],
  };
};

export default CamRoutes;
